import { render, staticRenderFns } from "./ManLoadDetails.vue?vue&type=template&id=5d151c0e&scoped=true&"
import script from "./ManLoadDetails.vue?vue&type=script&lang=js&"
export * from "./ManLoadDetails.vue?vue&type=script&lang=js&"
import style0 from "./ManLoadDetails.vue?vue&type=style&index=0&id=5d151c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d151c0e",
  null
  
)

export default component.exports